export default __webpack_public_path__ + "static/media/castration.80ab7441.png";